import styled from 'styled-components';

export const Tag = styled.div`
  text-transform: uppercase;
  border: 2px solid var(--c-neutral-1000);
  padding: var(--unit);
  border-radius: 2em;
  line-height: 1;
`;
